import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'benefits-list',
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), { myPoints() {
            var _a;
            const myPoints = Math.trunc((_a = this.currentProduct) === null || _a === void 0 ? void 0 : _a.currentPrice);
            return myPoints;
        } }),
});
